import { apiGet, apiPost } from './apiAdapter'

/**
 * 工单 #651：PC 官网端消息中心。
 * 复用 user 维度站内信端点 webofficial/notifications（非客户上下文接口，不带 X-Customer-Id），
 * 发货/反馈类通知由后端写入 notifications 表，此处负责 C 端展示与已读回执。
 */
interface CommerceApiResponse<T> {
  code: number
  message: string
  data: T
}

/** 站内信记录（后端 snake_case 字段经适配层转为 camelCase） */
export interface ClientNotificationRecord {
  id: number
  title: string
  content?: string | null
  type: string
  isRead: boolean
  readAt?: string | null
  createdAt: string
}

export interface ClientNotificationListResult {
  data: ClientNotificationRecord[]
  total: number
  page: number
  pageSize: number
}

/** 查询当前用户站内信列表 */
export const getNotificationsApi = (params: { page?: number; pageSize?: number; type?: string; isRead?: string }) =>
  apiGet<CommerceApiResponse<ClientNotificationListResult>>('webofficial/notifications', params)

/** 标记单条站内信已读 */
export const markNotificationReadApi = (id: number) =>
  apiPost<CommerceApiResponse<unknown>>(`webofficial/notifications/${id}/read`)

/** 全部标记已读 */
export const markAllNotificationsReadApi = () =>
  apiPost<CommerceApiResponse<unknown>>('webofficial/notifications/read-all')

/** 未读数量 */
export const getNotificationUnreadCountApi = () =>
  apiGet<CommerceApiResponse<{ count: number }>>('webofficial/notifications/unread-count')
